import { render, staticRenderFns } from "./EditOurFacility.vue?vue&type=template&id=667895d9&scoped=true&"
import script from "./EditOurFacility.vue?vue&type=script&lang=js&"
export * from "./EditOurFacility.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "667895d9",
  null
  
)

export default component.exports